import {Navigate} from "react-router-dom";
// import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import {lazy} from "react";
import PackageList from "../Packages/viewPackage";
import AdminPachages from "../SuperAdmin/Packages";
import CompanyList from "../SuperAdmin/company/company-list";
import MainLayout from "../MainLayout";

const Dashboard = Loadable(lazy(() => import('../Dashboard/index')));
const TeamPipelines = Loadable(lazy(() => import('../TeamPipelines/index')));
const SalsePipelines = Loadable(lazy(() => import('../SalesPipeline/index')));
const ContactList = Loadable(lazy(() => import('../Contacts/contact-list/index')));
const TeamList = Loadable(lazy(() => import('../Teams/team-list')));
const UserList = Loadable(lazy(() => import('../User/user-list')));
const UnauthorizedAccess = Loadable(lazy(() => import('../../utils/ui-components/UnauthorizedAccess')));

function AdminAuthorizedRoutes (user: any) {
    return [
        {
            path: "/",
            element: <MainLayout/>,
            children: [
                {
                    path: 'dashboard',
                    element: <Dashboard/>
                },
                {
                    path: 'team-pipelines',
                    element: <TeamPipelines/>
                },
                {
                    path: 'sales-pipelines',
                    element: <SalsePipelines/>
                },
                {
                    path: 'contact-list',
                    element: <ContactList/>
                },
                {
                    path: 'teams',
                    element: <TeamList/>
                },
                {
                    path: 'users',
                    element: <UserList/>
                },
                {
                    path: 'packages',
                    element: <PackageList/>
                },
                {
                    path: 'admin-packages',
                    element: <AdminPachages/>
                },
                {
                    path: 'admin-company',
                    element: <CompanyList/>
                },
                // {
                //     path: 'settings',
                //     element: <Configurations/>
                // },
            ]
        },
        {
            path: 'unauthorized',
            element: <UnauthorizedAccess/>
        },
        {
            path: '',
            element: <Navigate to="/dashboard"/>
        },
        {
            path: 'login',
            element: <Navigate to="/dashboard"/>
        },
        {
            path: "*",
            element: <Navigate to="/unauthorized"/>
        },
    ];
}

export default AdminAuthorizedRoutes;